import React, { useEffect, useState } from "react";
//CSS
import styles from "./InviteNewUser.module.css";
import Form from "../../Form/Form";
import FloatingLabelInput from "../../Form/FloatingLabelInput/FloatingLabelInput";
import FloatingLabelSelect from "../../Form/FloatingLabelSelect/FloatingLabelSelect";
import Button from "../../Button/Button";
import { FloatingLabelSelectOption } from "../../../../Types/Form/FloatingLabelSelectOption";
import { InviteNewUserRequest } from "../../../../Types/InviteRemoveUser/InviteNewUserRequest";
import { axiosInstance } from "../../../../Authentication/AxiosInterceptor";
import { toast } from "react-toastify";
import { InviteUserDisplayInfo } from "../../../../Types/InviteRemoveUser/InviteUserDisplayInfo";
import { useParams } from "react-router-dom";

type InviteNewUserProps = {
  roles: FloatingLabelSelectOption[];
  addClientUser: (user: InviteUserDisplayInfo) => void;
  areaId?: string;
  disabled?: boolean;
  onInvite?: (givenName: string, familyName: string, email: string, role: string) => Promise<void>;
};

const InviteNewUser = ({ roles, addClientUser, areaId: propAreaId, disabled = false, onInvite }: InviteNewUserProps) => {
  const { areaId: paramAreaId } = useParams();
  const areaId = propAreaId || paramAreaId;

  const [userData, setUserData] = useState<InviteNewUserRequest>({
    user: {
      given_name: "",
      family_name: "",
      email: "",
      name: "", 
    },
    roles: "",
    type: "Evaluate",
    areaId: areaId || "",
    clientId: process.env.REACT_APP_CLIENT_ID || "",
  });

  useEffect(() => {
    if (areaId) {
      setUserData((prev) => ({
        ...prev,
        areaId: areaId,
      }));
    }
  }, [areaId]);

  const handleGivenNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        given_name: e.target.value,
        name: `${e.target.value} ${prev.user.family_name}`,
      },
    }));
  }

  const handleFamilyNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        family_name: e.target.value,
        name: `${prev.user.given_name} ${e.target.value}`,
      },
    }));
  }
  
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        email: e.target.value,
      },
    }));
  }

  const handleRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setUserData((prev) => ({
      ...prev,
      roles: e.target.value,
    }));
  }

  const handleSubmit = async () => {
    if (onInvite) {
      try {
        await onInvite(userData.user.given_name, userData.user.family_name, userData.user.email, userData.roles);
        toast.success("User registered successfully!");
        setUserData({
          user: { given_name: "", family_name: "", email: "", name: "" },
          roles: "",
          type: "Evaluate",
          areaId: areaId || "",
          clientId: process.env.REACT_APP_CLIENT_ID || "",
        });
        addClientUser({ sub: "", fullName: userData.user.name, email: userData.user.email });
      } catch (error) {
        console.error("Error inviting user:", error);
        toast.error("Failed to register user. Please try again.");
      }
      return;
    }
    try {
      const response = await axiosInstance.post('InviteNewProductUser', userData);
      if (response.status === 200) {
        toast.success("User registered successfully!");
        setUserData({
          user: {
            given_name: "",
            family_name: "",
            email: "",
            name: "",
          },
          roles: "",
          type: "Evaluate",
          areaId: areaId || "",
          clientId: process.env.REACT_APP_CLIENT_ID || "",
        });
        addClientUser(response.data as InviteUserDisplayInfo);
      }
    } catch (error) {
      console.error("Error inviting user:", error);
    }
  };

  return (
    <div className={styles.container}>
      <h3>Invite New User</h3>
      <Form>
        <FloatingLabelInput label="Enter First Name" value={userData.user.given_name} onChange={handleGivenNameChange} disabled={disabled}/>
        <FloatingLabelInput label="Enter Last Name" value={userData.user.family_name} onChange={handleFamilyNameChange} disabled={disabled} />
        <FloatingLabelInput label="Enter Email address"  value={userData.user.email} onChange={handleEmailChange}  type="email" disabled={disabled}/>
        <FloatingLabelSelect label="Select Role" options={roles} value={userData.roles} onChange={handleRoleChange} disabled={disabled} />
        <Button type="button" size={"Small"} clickHandler={handleSubmit} disabled={disabled}>Register new user</Button>
      </Form>
    </div>
  );
};

export default InviteNewUser;
